import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-date-time',
  components: {},
})
export default class DisplayFieldDateTime extends mixins(AbstractDisplayField) {
  get formatDateTime(): string {
    return this.$bpcHelper.formatDateTime(this.value);
  }
}
